import axiosRetry from 'axios-retry';
import { axiosWithHeaders } from '@innovyze/lib_get_service';
import config from './config.api';

const sensorGroup = axiosWithHeaders({
	service: 'sensorGroup',
	config,
});

axiosRetry(sensorGroup, {
	retries: 3,
	retryDelay: retryCount => {
		return retryCount * 1000;
	},
});

export default sensorGroup;
